(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rt-banner-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.rtReady) return;
      root.dataset.rtReady = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll('.rt-bs__slide'));
      if (slides.length < 2) return;
      var dots = Array.prototype.slice.call(root.querySelectorAll('.rt-bs__dot'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var auto = root.dataset.autoplay === 'true' && !reduce;
      var ms = Math.max(3, parseInt(root.dataset.interval, 10) || 6) * 1000;
      var cur = 0;
      var timer = null;
      function show(n) {
        cur = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          var on = i === cur;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          var a = s.querySelector('a');
          if (a) a.tabIndex = on ? 0 : -1;
        });
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function play() { stop(); if (auto) timer = setInterval(function () { show(cur + 1); }, ms); }
      root.addEventListener('click', function (e) {
        var d = e.target.closest('.rt-bs__dot');
        if (d) { show(parseInt(d.dataset.i, 10)); play(); return; }
        var n = e.target.closest('.rt-bs__nav');
        if (n) { show(cur + parseInt(n.dataset.dir, 10)); play(); }
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
      show(0);
      play();
    }
    function initAll() { document.querySelectorAll('[data-rt-bs]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rt-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.rtpReady) return;
      root.dataset.rtpReady = '1';

      var main = root.querySelector('[data-main-img]');
      var thumbs = root.querySelectorAll('.rtp-thumb');
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          if (main) {
            main.src = b.dataset.full;
            main.removeAttribute('srcset');
            main.alt = b.dataset.alt || main.alt;
          }
          thumbs.forEach(function (t) { t.setAttribute('aria-current', t === b ? 'true' : 'false'); });
        });
      });
      var list = root.querySelector('[data-thumbs]');
      root.querySelectorAll('[data-thumb-dir]').forEach(function (a) {
        a.addEventListener('click', function () {
          if (list) list.scrollBy({ top: parseInt(a.dataset.thumbDir, 10) * 180, behavior: 'smooth' });
        });
      });

      var dlg = root.querySelector('[data-zoom-dialog]');
      var zoom = root.querySelector('[data-zoom]');
      if (dlg && zoom && main) {
        zoom.addEventListener('click', function () {
          var img = dlg.querySelector('[data-zoom-img]');
          img.src = main.src;
          if (dlg.showModal) dlg.showModal(); else window.open(main.src, '_blank');
        });
        dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-zoom-close]')) dlg.close(); });
      }

      var qty = root.querySelector('.rtp-qty input');
      root.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qty, 10);
          qty.value = Math.max(1, v);
        });
      });

      var sel = root.querySelector('[data-variants]');
      if (sel) {
        var sym = root.querySelector('[data-price]').textContent.trim().charAt(0);
        sel.addEventListener('change', function () {
          var o = sel.options[sel.selectedIndex];
          root.querySelector('[data-price]').textContent = sym + o.dataset.price;
          var cmp = root.querySelector('[data-compare]');
          var sv = root.querySelector('[data-save]');
          if (o.dataset.compare) {
            var s = o.dataset.save.split('|');
            cmp.textContent = sym + o.dataset.compare; cmp.hidden = false;
            sv.textContent = 'Save ' + sym + s[0] + ' (' + s[1] + '%)'; sv.hidden = false;
          } else { cmp.hidden = true; sv.hidden = true; }
          var ok = o.dataset.available === 'true';
          var st = root.querySelector('[data-stock]');
          st.textContent = ok ? 'In stock' : 'Out of stock';
          st.classList.toggle('is-out', !ok);
          root.querySelectorAll('[data-add], [data-buy]').forEach(function (b) { b.disabled = !ok; });
        });
      }

      var tabs = root.querySelectorAll('[role=tab]');
      function pick(t) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var p = root.querySelector('#' + x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { pick(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
            pick(n); n.focus();
          }
        });
      });
    }
    function initAll() { document.querySelectorAll('[data-rtp]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
